<div class="topbar clearfix">
    <!--<a href="#" id="menu-button" (click)="app.onMenuButtonClick($event,0)">
        <span class="fa fa-angle-left"></span>
    </a>-->
    <a href="#" id="menu-button" (click)="toggleHeartbeat($event)">
        <div class="spinner" *ngIf="pollingStatus == 'Ok'" matTooltip="Click to freeze updates"
            matTooltipPosition="right">
            <div class="rect1"></div>
            <div class="rect2"></div>
            <div class="rect3"></div>
            <div class="rect4"></div>
            <div class="rect5"></div>
        </div>
        <div class="status-indicator" *ngIf="pollingStatus == 'Unstable'">
            <i class="fa fa-exclamation-triangle fa-2x"></i>
        </div>
        <div class="" *ngIf="pollingStatus == 'Disconnected'">
            <div class="fa-stack fa-lg">
                <i class="fa fa-signal fa-stack-1x"></i>
                <i class="fa fa-ban fa-stack-2x fa-flip-horizontal"></i>
            </div>
        </div>
        <div class="status-indicator" *ngIf="pollingStatus == 'Paused'" matTooltip="Click to resume live updates"
            matTooltipPosition="right">
            <i class="fa fa-snowflake-o fa-2x fa-spin"></i>
        </div>
        <div class="status-indicator" *ngIf="pollingStatus == 'Fixed Date'" matTooltip="Click to resume live updates"
            matTooltipPosition="right">
            <i class="fa fa-refresh fa-2x"></i>
        </div>
    </a>
    <a class="morpheus-logo-link" href="#">
        <img src="assets/title_logo.png" class="morpheus-logo" />
    </a>
    <!--<button id="topbar-critical-message-button" pButton type="button" class="p-button-danger topbar-critical-message-button" [label]="app.criticalAlertMessage"></button>-->
    <p-messages *ngIf="emergencyMessages != null && emergencyMessages.length > 0" class="emergency-bar"
        [(value)]="emergencyMessages"></p-messages>
    <p-message *ngFor="let systemMessage of systemMessages" class="system-message" [severity]="severity(systemMessage)"
        [text]="systemMessage.message"></p-message>
    <!-- <a id="topbar-menu-button" href="#" (click)="app.onTopbarMenuButtonClick($event)">
        <i class="fa fa-bars"></i>
    </a> -->

    <!-- <ul class="topbar-menu fadeInDown" [ngClass]="{'topbar-menu-visible': app.topbarMenuActive}"> -->
    <ul class="topbar-menu fadeInDown" fxLayout="row">
        <!-- <li #notifications [ngClass]="{'active-topmenuitem':app.activeTopbarItem === notifications}">
            <a href="#" (click)="app.onTopbarItemClick($event,notifications)">
                <mat-icon class="topbar-icon">info_outline</mat-icon>
                <span *ngIf="notificationCount > 0" class="topbar-badge animated rubberBand">{{ notificationCount }}</span>
                <span class="topbar-item-name">Notifications</span>
            </a>
            <ul class="fadeInDown">
                <li role="menuitem">
                    <a href="#">
                        <i class="fa fa-fw fa-tasks"></i>
                        <span>Pending tasks</span>
                        <span class="topbar-submenuitem-badge">6</span>
                    </a>
                </li>
                <li role="menuitem">
                    <a href="#">
                        <i class="fa fa-fw fa-calendar-check-o"></i>
                        <span>Meeting today at 3pm</span>
                    </a>
                </li>
                <li role="menuitem">
                    <a href="#">
                        <i class="fa fa-fw fa-download"></i>
                        <span>Download documents</span>
                    </a>
                </li>
                <li role="menuitem">
                    <a href="#">
                        <i class="fa fa-fw fa-plane"></i>
                        <span>Book flight</span>
                    </a>
                </li>
            </ul>
        </li> -->

        <!-- <li #settings [ngClass]="{'active-topmenuitem':app.activeTopbarItem === settings}">
            <a href="#" (click)="app.onTopbarItemClick($event,settings)"> 
                <i class="topbar-icon fa fa-fw fa-sliders"></i>
                <span class="topbar-item-name">Settings</span>
            </a>
            <ul class="fadeInDown">
                <li role="menuitem">
                    <a href="#">
                        <i class="fa fa-fw fa-paint-brush"></i>
                        <span>Change Theme</span>
                    </a>
                </li>
                <li role="menuitem">
                    <a href="#">
                        <i class="fa fa-fw fa-star-o"></i>
                        <span>Favorites</span>
                    </a>
                </li>
                <li role="menuitem">
                    <a href="#">
                        <i class="fa fa-fw fa-lock"></i>
                        <span>Lock Screen</span>
                    </a>
                </li>
                <li role="menuitem">
                    <a href="#">
                        <i class="fa fa-fw fa-picture-o"></i>
                        <span>Wallpaper</span>
                    </a>
                </li>
            </ul>
        </li> -->
        <!-- <li #profile class="profile-item" [ngClass]="{'active-topmenuitem':app.activeTopbarItem === profile}">
            <a href="#" (click)="app.onTopbarItemClick($event,profile)">
                <div class="profile-image">
                    <i *ngIf="applicationConfigurationComponent.base64Avatar == null" class="topbar-icon fa fa-fw fa-user-circle"></i>
                    <img *ngIf="applicationConfigurationComponent.base64Avatar != null" max-width="100%" max-height="100%" class="topbar-icon avatar" [src]="applicationConfigurationComponent.base64Avatar"
                    />
                </div>
                <span class="profile-text">Profile</span>
            </a>

            <ul class="fadeInDown">
                <li role="menuitem" (click)="applicationConfigurationVisible()">
                    <a href="#">
                        <i class="fa fa-fw fa-sliders"></i>
                        <span>Settings</span>
                    </a>
                </li>
                <li role="menuitem" (click)="openChangeProfileDialog()">
                    <a href="#">
                        <i class="fa fa-fw fa-users"></i>
                        <span>Switch Profile</span>
                    </a>
                </li>

                <li role="menuitem" (click)="aboutVisible=true">
                    <a href="#">
                        <i class="fa fa-fw fa-info-circle"></i>
                        <span>About</span>
                    </a>
                </li>
                <li role="menuitem">
                    <a [routerLink]="['/logout']">
                        <i class="fa fa-fw fa-sign-out"></i>
                        <span>Logout</span>
                    </a>
                </li>
            </ul>
        </li> -->

    </ul>

    <div [fxHide]="appConfig.showApplicationIdentifiers" fxFlex="1 1 auto"></div>
    <div [fxHide]="!appConfig.showApplicationIdentifiers" fxFlex="1 1 auto" fxLayout="row"
        class="application-identifier-container">
        <div fxFlex="1 1 auto"></div>
        <div fxFlex="0 0 auto" fxLayout="column">
            <div fxFlex="0 0 auto" fxLayout="row" class="application-identifier"
                [ngClass]="'application-identifier-' + appConfig.applicationIdentificationColorIndex">
                <mat-icon  style="transform: rotate(180deg)" [ngClass]="'application-identifier-color-' +  appConfig.applicationIdentificationColorIndex">workspaces</mat-icon>
                <span fxFlex="1 1 auto"
                    class="application-identifier-text">{{appConfig.getTenantInfo().tenantId}}</span>
                <span fxFlex="1 1 auto" class="application-identifier-text"
                    *ngIf="appConfig.applicationIdentificationDescription"> -
                    {{appConfig.applicationIdentificationDescription}}</span>
                <mat-icon style="transform: rotate(180deg)" [ngClass]="'application-identifier-color-' +  appConfig.applicationIdentificationColorIndex">workspaces</mat-icon>
            </div>
        </div>
        <div fxFlex="1 1 auto"></div>
    </div>
    <button mat-icon-button [matMenuTriggerFor]="menu" class="avatar-button">
        <i *ngIf="applicationConfigurationComponent.base64Avatar == null" max-width="100%" max-height="100%"
            class="topbar-icon fa fa-3x fa-user-circle avatar"></i>
        <img *ngIf="applicationConfigurationComponent.base64Avatar != null" max-width="100%" max-height="100%"
            class="topbar-icon avatar" [src]="applicationConfigurationComponent.base64Avatar" />
    </button>
    <mat-menu #menu="matMenu" yPosition="below" [overlapTrigger]="false">
        <button mat-menu-item role="menuitem" (click)="applicationConfigurationVisible()">
            <i class="fa fa-fw fa-sliders"></i>
            <span>Settings</span>
        </button>
        <button mat-menu-item role="menuitem" (click)="openChangeProfileDialog()">
            <i class="fa fa-fw fa-users"></i>
            <span>Switch Profile</span>
        </button>
        <button mat-menu-item role="menuitem" (click)="openDocumentationDialog()">
            <i class="fa fa-fw fa-thumbs-o-up"></i>
            <span>Documentation & Guides</span>
        </button>
        <button mat-menu-item role="menuitem" (click)="debugVisible=true">
            <i class="fa fa-fw fa-cogs"></i>
            <span>Advanced Mode</span>
        </button>
        <button mat-menu-item role="menuitem" (click)="aboutVisible=true">
            <i class="fa fa-fw fa-info-circle"></i>
            <span>About</span>
        </button>
        <button mat-menu-item role="menuitem" (click)="logout()">
            <i class="fa fa-fw fa-sign-out"></i>
            <span>Logout</span>
        </button>
    </mat-menu>
</div>
<p-dialog header="About" [(visible)]="aboutVisible" modal="modal">
    <p>Pipeline: {{ pipelineNumber }}</p>
    <p>Build: {{ buildNum }}</p>
    <p>Sha1: {{ buildSha1 }}</p>
    <p>Date: {{ buildDate }}</p>

</p-dialog>
<p-dialog header="Advanced Mode (Caution: advanced Usage Only)" [(visible)]="debugVisible" modal="modal"
    [style]="{width: '80%', height: '80%'}">
    <p-terminal welcomeMessage="Advanced mode session initiated" prompt="liquitics $"></p-terminal>
</p-dialog>
<app-application-configuration></app-application-configuration>